import React from 'react'

import { Modal } from '@/shared/components/ui/modal'
import { ampli } from '@/shared/lib/ampli'

import { useExportConfiguration } from './ExportConfigurationProvider'
import { ExportFieldsModalContent } from './ExportFieldsModal'
import { ExportParamsModalContent } from './ExportParamsModal'

type ExportModalProps = {
	isOpen: boolean
	close(): void
}

export default function ExportModal({ close, isOpen }: ExportModalProps) {
	const {
		kind,
		isAdditional,
		isLoading,
		state: { step, setStep, fields, draftFormData },
		options,
		handleColumnsSubmit,
		handleParamsSubmit,
	} = useExportConfiguration()

	const handleClose = () => close()

	return (
		<Modal
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					close()
				}
			}}
		>
			{step === 'params' ? (
				<ExportParamsModalContent
					isAdditional={isAdditional}
					isLoading={isLoading}
					onSubmit={handleParamsSubmit}
					onClose={handleClose}
					defaultValues={draftFormData}
					options={options}
				/>
			) : (
				<ExportFieldsModalContent
					isLoading={isLoading}
					onSubmit={handleColumnsSubmit}
					onClose={handleClose}
					onBack={() => {
						ampli.exportParamsFieldsConfigurationBack({
							export_kind: kind,
						})
						setStep('params')
					}}
					defaultValues={{
						fields,
					}}
				/>
			)}
		</Modal>
	)
}
